<template>
  <el-container class="loginbox">
    <el-form
      ref="AccountFrom"
      :model="account"
      :rules="rules"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <h3
        class="title"
        style="font-size: 22px; text-align: center; margin: 0 auto 40px"
      >
        新型经营主体名录库管理系统
      </h3>
      <el-form-item prop="username">
        <el-input
          type="text"
          v-model="account.username"
          auto-complete="off"
          placeholder="账号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input
          type="password"
          v-model="account.pwd"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-form-item style="width: 100%">
        <el-button
          type="primary"
          style="width: 100%"
          @click.native.prevent="beforeLogin"
          :loading="loading"
          >登录
        </el-button>
      </el-form-item>
    </el-form>
    <el-footer>Copyright © 2019 北京世纪国源科技股份有限公司</el-footer>
  </el-container>
</template>
<script>
import API from "../api/api_user";
import Cookies from "js-cookie";
import base64 from "../common/base64";
import area_api from "../api/api_common";

export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      account: {
        username: "",
        pwd: "",
        deptId: "",
      },
      deptList: [],
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      deptOptionVisible: false,
      // checked: true
    };
  },
  mounted() {
    localStorage.removeItem("menus");
  },
  methods: {
    //点击登录按钮后，先获取机构列表，选择机构后登录
    beforeLogin() {
      this.$refs.AccountFrom.validate((valid) => {
        if (valid) {
          this.doLogin();
        }
      });
    },
    async doLogin() {
      let appId = process.env.appId;
      this.dialogVisible = false;
      this.loading = true;
      let loginParams = base64.encodeBase64Content(
        JSON.stringify({
          username: this.account.username,
          password: this.account.pwd,
          appId,
        })
      );
      try {
        let result = await API.login({ logindto: loginParams });
        if (result && result.code === 0) {
          Cookies.set("token", result.token);
          this.loginComplete();

          // this.$router.push({path: "/"});
        } else {
          this.GLOBAL.warning(result.msg || "登录失败!");
        }
      } catch (err) {
        console.error("登录失败!");
      } finally {
        this.loading = false;
      }
    },
    async loginComplete() {
      try {
        let result = await API.userInfo({
          accountName: this.account.username,
        });
        if (result && result.code === 0) {
          if (result.data.user && result.data.user.roleList) {
            localStorage.setItem(
              "roleList",
              JSON.stringify(result.data.user.roleList)
            );
            console.log("roleList",result.data.user.roleList)
            result.data.user.roleList.map(item=>{
              if(item.roleCode==19|| item.roleCode==21){
                Cookies.set('roleCode',item.roleCode)
                return
              }
            })

          }
          this.$store.commit("LOGIN", result.data.user);

          // alert(Cookies.get('curAreaCode'));// 当前行政区划代码
          this.getNextXzqData(Cookies.get("curAreaCode")); //获取乡级以上行政区信息

          this.$router.push({ path: "/homepage/home" });
        } else {
          this.GLOBAL.warning(result.msg || "登录失败!");
        }
      } catch (err) {
        console.error("登录失败!");
      } finally {
        this.loading = false;
      }
    },
    /*用户名变化事件---修改用户名后隐藏机构选择框*/
    userNameChange() {
      this.deptOptionVisible = false;
      this.resetDeptOption();
    },

    /*重置机构下拉框*/
    resetDeptOption() {
      this.deptList = [];
      this.account.deptId = "";
    },

    // async getNextXzqData(areaCode) {//获取乡级以上行政区信息
    async getNextXzqData(areaCode) {
      //获取乡级以上行政区信息
      console.log("行政区划开始加载！");
      console.log("---------------------------");
      localStorage.setItem("areaOptions", "");
      let areaDataOption1 = [];
      let areaR = area_api.getXzqData({ areaCode: areaCode, userAreaCode: 1 });
      let areaData = await areaR;
      if (areaData.code != 0) {
        return;
      }
      // areaDataOption1 = [{value: areaData.data[0].qhdm, label: areaData.data[0].qhmc}];
      areaDataOption1 = areaData.data[0];
      localStorage.setItem("areaOptions", JSON.stringify(areaDataOption1));
      this.GLOBAL.eventBus.$emit("firstLoadAreaOption");
      if (areaData.data[0].qhdm.length === 9) {
        //若为乡级 则直接返回数据
        // return;
      }

      if (areaData.data[0].qhdm.length === 6) {
        //若为县级 则返回子级数据
        /* if(areaData.data[0].children.length>0){
            areaDataOption1.push(areaData.data[0].children);
          }*/
        // localStorage.setItem("areaOptions",JSON.stringify(areaDataOption1));
        // return;
      }

      if (areaData.data[0].qhdm.length === 4) {
        //若为地市级 则返回子级数据
        let areaDataOption2 = areaData.data[0].children;
        for (var c = 0; c < areaDataOption2.length; c++) {
          let areaR2 = area_api.getXzqData({
            areaCode: areaDataOption2[c].qhdm,
            userAreaCode: 1,
          });
          let areaData2 = await areaR2;
          areaDataOption1.children[c].children = areaData2.data[0].children;
        }
        // localStorage.setItem("areaOptions",JSON.stringify(areaDataOption1));
        // return;
      }

      if (areaData.data[0].qhdm.length === 2) {
        //若为省级 则返回子级数据
        let areaDataOption2 = areaData.data[0].children;
        for (var c = 0; c < areaDataOption2.length; c++) {
          let areaR2 = area_api.getXzqData({
            areaCode: areaDataOption2[c].qhdm,
            userAreaCode: 1,
          });
          let areaData2 = await areaR2;
          areaDataOption1.children[c].children = areaData2.data[0].children;

          let areaDataOption3 = areaDataOption1.children[c].children;
          for (var v = 0; v < areaDataOption3.length; v++) {
            let areaR3 = area_api.getXzqData({
              areaCode: areaDataOption3[v].qhdm,
              userAreaCode: 1,
            });
            let areaData3 = await areaR3;
            areaDataOption1.children[c].children[v].children =
              areaData3.data[0].children;
          }
        }
      }

      if (areaData.data[0].qhdm === "1") {
        //若为全国管理员1 则返回子级数据
        let areaDataOption2 = areaData.data[0].children;
        for (var c = 0; c < areaDataOption2.length; c++) {
          let areaR2 = area_api.getXzqData({
            areaCode: areaDataOption2[c].qhdm,
            userAreaCode: 1,
          });
          let areaData2 = await areaR2;
          areaDataOption1.children[c].children = areaData2.data[0].children;

          let areaDataOption3 = areaDataOption1.children[c].children;
          for (var v = 0; v < areaDataOption3.length; v++) {
            let areaR3 = area_api.getXzqData({
              areaCode: areaDataOption3[v].qhdm,
              userAreaCode: 1,
            });
            let areaData3 = await areaR3;
            areaDataOption1.children[c].children[v].children =
              areaData3.data[0].children;

            let areaDataOption4 =
              areaDataOption1.children[c].children[v].children;
            for (var x = 0; x < areaDataOption4.length; x++) {
              let areaR4 = area_api.getXzqData({
                areaCode: areaDataOption4[x].qhdm,
                userAreaCode: 1,
              });
              let areaData4 = await areaR4;
              areaDataOption1.children[c].children[v].children[x].children =
                areaData4.data[0].children;
            }
          }
        }
      }

      localStorage.setItem("areaOptions", JSON.stringify(areaDataOption1));
      this.GLOBAL.eventBus.$emit("areaOptionsCompleted");
      console.log("---------------------------");
      console.log("行政区划加载完成！");
      return;
    },
  },
};
</script>

<style>
.loginbox {
  background: #dfe9fb;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  background-image: url(../../static/img/loginbackground.png);
}
</style>
<style scoped lang="less">
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 160px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  background: -ms-linear-gradient(top, #ace, #00c1de); /* IE 10 */
  background: -moz-linear-gradient(top, #ace, #00c1de); /*火狐*/
  background: -webkit-gradient(
    linear,
    0% 0%,
    0% 100%,
    from(#ace),
    to(#00c1de)
  ); /*谷歌*/
  background: -webkit-linear-gradient(
    top,
    #ace,
    #00c1de
  ); /*Safari5.1 Chrome 10+*/
  background: -o-linear-gradient(top, #ace, #00c1de);

  /*Opera 11.10+*/

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }
}
.el-container {
  height: 100%;
}

.el-footer {
  height: 25px !important;
  position: absolute;
  bottom: 0;
  line-height: 25px;
  color: #e1e7e7;
  width: 100%;
  text-align: center;
  font: "Microsoft Yahei";
  font-size: 12px;
  letter-spacing: 1px;
}
</style>




// WEBPACK FOOTER //
// src/studio/login.vue